import { useEffect, useState } from "react";
import { fz } from "@/lib/fanzone";
import { Crown, Flame } from "lucide-react";

export default function Leaderboard() {
  const [period, setPeriod] = useState("all");
  const [data, setData] = useState(null);

  useEffect(() => {
    fz.leaderboard(period).then(({ data: d }) => setData(d)).catch(() => {});
  }, [period]);

  return (
    <div className="titans-card p-5 md:p-6" data-testid="fz-leaderboard">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <Crown size={16} className="text-titans-blue" />
          <span className="font-display text-xl uppercase">Fan Leaderboard</span>
        </div>
        <div className="flex gap-1">
          {[["all", "All-Time"], ["week", "This Week"]].map(([k, l]) => (
            <button
              key={k}
              onClick={() => setPeriod(k)}
              data-testid={`fz-lb-period-${k}`}
              className={`px-4 py-1.5 font-cond uppercase tracking-wider text-xs border transition-colors ${
                period === k ? "bg-titans-red border-titans-red text-white" : "border-[rgba(138,141,143,0.3)] text-titans-silver hover:border-titans-blue"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>

      {!data ? (
        <div className="text-titans-silver text-sm">Loading…</div>
      ) : data.entries.length === 0 ? (
        <div className="text-titans-silver text-sm" data-testid="fz-lb-empty">
          No named fans yet — claim your name in the profile bar and start climbing.
        </div>
      ) : (
        <div className="space-y-1.5">
          {data.entries.map((e, i) => (
            <div
              key={i}
              data-testid={`fz-lb-row-${i}`}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg ${
                data.me && !data.me.rank !== e.rank && data.me.name === e.name ? "bg-titans-blue/10 border border-titans-blue/40" : i % 2 ? "bg-[#F8FAFC]" : ""
              }`}
            >
              <span className={`font-display text-lg w-8 text-center shrink-0 ${e.rank === 1 ? "text-titans-red" : e.rank <= 3 ? "text-titans-blue" : "text-titans-silver"}`}>
                {e.rank}
              </span>
              <span className="font-cond uppercase tracking-wide text-sm flex-1 truncate">{e.name}</span>
              <span className="font-cond uppercase tracking-wider text-[10px] text-titans-silver shrink-0">Lv {e.level}</span>
              {e.streak > 1 && (
                <span className="inline-flex items-center gap-0.5 text-titans-red font-cond text-[10px] shrink-0">
                  <Flame size={10} /> {e.streak}
                </span>
              )}
              <span className="font-display text-lg text-titans-blue tabular-nums shrink-0">{e.xp.toLocaleString()}</span>
            </div>
          ))}
        </div>
      )}

      {data?.me && !data.entries.some((e) => e.name === data.me.name) && (
        <div className="mt-3 flex items-center gap-3 px-3 py-2.5 rounded-lg bg-titans-blue/10 border border-titans-blue/40" data-testid="fz-lb-me">
          <span className="font-display text-lg w-8 text-center text-titans-blue">{data.me.rank}</span>
          <span className="font-cond uppercase tracking-wide text-sm flex-1">{data.me.name || "You (unnamed)"}</span>
          <span className="font-display text-lg text-titans-blue tabular-nums">{data.me.xp.toLocaleString()}</span>
        </div>
      )}
    </div>
  );
}
